function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#c9eef7;}.cls-3{fill:#9ae0ec;}.cls-4{fill:#405063;}.cls-5{fill:#faad8f;}.cls-6{fill:#f79071;}.cls-7{fill:#6dc9f0;}.cls-8{fill:#56b7e7;}.cls-9{fill:#bcc751;}.cls-10{fill:#889e3c;}.cls-11{fill:#8d953d;}.cls-12{fill:#3596bc;}.cls-13{fill:#9ad4f1;}"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  width: 5000,
  height: 5000
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3710.43,3037l51.21,19.17s59.49-237.69,300.5-573.63C4062.14,2482.57,3796.76,2685.64,3710.43,3037Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4073,2856.79c-145.39-108.58-243,58.65-243,58.65C3922.38,3017.2,4073,2856.79,4073,2856.79Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3660.5,2667.13s-15,148.48,94,189C3754.54,2856.12,3842.13,2712.1,3660.5,2667.13Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4138.19,2708c-157.76-89.84-227.42,61.23-227.42,61.23C4017.27,2814.41,4138.19,2708,4138.19,2708Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3975.71,2403.58c-69.56,73.7-14.18,125.3-14.18,125.3C4014.09,2468.09,3975.71,2403.58,3975.71,2403.58Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3856.62,2495.18s-44,106,28.79,139.43C3885.41,2634.61,3943.77,2545,3856.62,2495.18Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3773.23,2578.48s-29.22,112.6,45.27,149.34C3818.5,2727.82,3878.62,2641.42,3773.23,2578.48Z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4047.2,2451.07s68.9-64.76,48.82-160C4096,2291.06,3994.11,2372.8,4047.2,2451.07Z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4210.74,2442.9c-100.57-24.61-141.36,71.84-141.36,71.84C4146.06,2540.78,4210.74,2442.9,4210.74,2442.9Z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4130.62,2402.27s108.26-13.9,171.67-205.57C4302.29,2196.7,4136,2263.93,4130.62,2402.27Z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4142.65,2576.33c-124-28-160.66,67.68-160.66,67.68C4062.7,2668.84,4142.65,2576.33,4142.65,2576.33Z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1140,4109.5l4.32-54.5s-244.88,8.26-634.21-130.91C510.08,3924.09,778.39,4123.28,1140,4109.5Z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M866.84,3810.58c-64.34,169.67,123.3,217.47,123.3,217.47C1062.53,3911.21,866.84,3810.58,866.84,3810.58Z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M798.12,4259.37S945,4232.91,953.9,4116.92C953.9,4116.92,791.33,4072.38,798.12,4259.37Z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M705.89,3788.89c-42.93,176.4,121.48,201.76,121.48,201.76C841.45,3875.84,705.89,3788.89,705.89,3788.89Z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M458,4028.93c90,46.58,124.36-20.87,124.36-20.87C509.4,3974.27,458,4028.93,458,4028.93Z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M578.81,4118.18s114,13.08,126.11-66.06C704.92,4052.12,602.73,4020.68,578.81,4118.18Z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M681.85,4175.41s116.29-2.92,131.1-84.64C813,4090.77,713.34,4056.76,681.85,4175.41Z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M483.92,3947.13s-81.23-48.41-167.27-2.87C316.65,3944.26,423.29,4019.71,483.92,3947.13Z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M431,3792.16c4,103.45,108,116.11,108,116.11C542.94,3827.38,431,3792.16,431,3792.16Z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M414,3880.37S370.86,3780.13,169.14,3772C169.14,3772,279.57,3913.34,414,3880.37Z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M578,3820.87c7.25,126.91,109.31,135.81,109.31,135.81C689,3872.25,578,3820.87,578,3820.87Z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4148,3892.28l-26.75-47.69s225.84-95,521.11-384.45C4642.35,3460.14,4482.12,3753.38,4148,3892.28Z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4270.85,3506.46c129.47,127.13-20.91,249.11-20.91,249.11C4135.28,3679.78,4270.85,3506.46,4270.85,3506.46Z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4521.18,3885.23s-144.45,37.47-201.11-64.13C4320.07,3821.1,4449,3712.57,4521.18,3885.23Z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4407.93,3419.36c112.84,142.21-25.84,234.1-25.84,234.1C4321.23,3555.09,4407.93,3419.36,4407.93,3419.36Z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4733.59,3533.52c-62.23,80-121.67,33.12-121.67,33.12C4664,3505.42,4733.59,3533.52,4733.59,3533.52Z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4661.22,3665.18S4563.13,3724.8,4519,3658C4519,3658,4598.66,3586.65,4661.22,3665.18Z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4591.61,3760.29s-106.83,46.05-154.49-22C4437.12,3738.32,4513.33,3665.73,4591.61,3760.29Z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4675.76,3470.11s53.49-78,150.69-72.65C4826.45,3397.46,4761.21,3510.63,4675.76,3470.11Z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4658.9,3307.23c39.65,95.64-49.45,150.66-49.45,150.66C4572,3386.08,4658.9,3307.23,4658.9,3307.23Z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4711.27,3380.22s-2.77-109.11,177-201C4888.25,3179.21,4847.18,3353.85,4711.27,3380.22Z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4537.41,3394.86C4584,3513.15,4495,3564,4495,3564,4458.17,3488,4537.41,3394.86,4537.41,3394.86Z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3636.68,4014.24c47.89-6,95.39-12.67,139.39,5.17,27,10.92,50.46,30.6,71.22,50.54,18.8,18.06,32.11,40.18,53.2,56.75,42.68,33.54,97.29,52.28,151.69,49.75,16.62-.77,34-3.74,47-14.15,13.81-11.08,20.51-29.14,21.67-46.8,2.43-37.09-16.06-73.09-7.27-110.27,11.08-46.9,71.72-73.38,112.91-49.31,18.47,10.79,34.84,30.06,56.07,28.22,28.57-2.46,39-40,36.37-68.95s-10-61.82,8-84.4c37.72-47.12,129.78,11.6,167.8-35.26,20.08-24.74,7.65-64.63-17.17-84.47s-57.59-25.17-88.69-30.8-63.94-13.22-86.22-35.94c-35.3-36-30.88-95.21-16.7-143.89,6.37-21.88,13.93-46.68,2.5-66.33-8.6-14.77-26.56-22.22-43.44-21.24s-32.64,9.27-45.9,19.92c-29.83,24-48.33,59.11-68.6,91.79s-45.1,65.35-80.73,78.88-83.81-.88-94.63-37.9c-6.47-22.1,1.36-45.53,4-68.43s-3.51-51-24.89-58.77c-17.13-6.24-35.69,3.7-50.25,14.77-54.59,41.47-92.66,104.72-104.1,173-4.35,25.94-5,52.64-12.62,77.8s-23.91,49.62-48.59,57.7c-26,8.52-54.95-2.83-81.49,3.87-31.34,7.9-51.26,38.23-68.11,66.19-18.11,30-35,73.71-63.77,93.88-21.13,14.82-42.07,33.34-22.26,62.79,13.2,19.63,37.91,27.65,61.19,30.19C3574.66,4021.81,3605.75,4018.15,3636.68,4014.24Z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M4479.23,3723.22a7.08,7.08,0,0,0-5.73-8.2c-1.13-.2-114.39-19.86-274-13.55A1541.3,1541.3,0,0,0,4030,3717.55c85-68.14,200.95-201.47,206.29-207.62a7.07,7.07,0,0,0-10.69-9.26c-1.41,1.62-141.52,162.71-225.44,221.72a1343.69,1343.69,0,0,0-190,47c45.63-91.91,132-233.13,132.91-234.62a7.08,7.08,0,1,0-12.07-7.39c-1,1.57-95.84,156.72-139.66,248.36a1120,1120,0,0,0-161.13,70,7.07,7.07,0,1,0,6.67,12.47q34.07-18.2,68.65-33.52c18.56,119,207.68,183.24,244.91,194.77,3.21,1,5.35,1.37,6.11,1.58a7.29,7.29,0,0,0,8.81-5.08c1.05-3.7-.91-8-4.57-9.15l-.15,0c-2.27-.7-226.24-65.52-241.47-188.05,103-44.19,207.76-70.59,305.05-85.72,134.43,48.66,204.19,153.53,204.88,154.59a7.07,7.07,0,0,0,11.84-7.73c-2.75-4.23-65-98.07-188.58-151,232.49-31.58,415.8-.46,418.65,0A7.07,7.07,0,0,0,4479.23,3723.22Z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3624,3857.07a10.81,10.81,0,0,1,4.44-14.63,1127.07,1127.07,0,0,1,160.19-69.77c43.28-90.08,135.21-240.8,139.12-247.2l.06-.09a10.82,10.82,0,0,1,14.86-3.57,10.82,10.82,0,0,1,3.57,14.87c-.83,1.34-82.33,134.61-128.74,226.35a1354.92,1354.92,0,0,1,181.16-44.18c83.5-59,222.69-219,224.09-220.63a10.81,10.81,0,1,1,16.33,14.16c-4.73,5.45-112.34,129.16-196.32,199.52a1544.19,1544.19,0,0,1,156.52-14.16c160-6.33,273.7,13.4,274.84,13.6a10.84,10.84,0,0,1,8.75,12.52h0a10.83,10.83,0,0,1-12.52,8.76c-1.78-.32-177.21-30.57-404.38-1.75,116.64,54.14,175.56,143.06,178.09,146.94a10.81,10.81,0,0,1-18.1,11.82c-.68-1-69.64-104.49-202.12-152.8C3916,3753.68,3814.94,3782,3723.29,3821c9.1,59.64,70.4,105,120.66,132.67,54.23,29.87,107.42,46.39,117.53,49.4l.3.09-1.11,3.57,1.26-3.53c5.46,1.7,8.69,8,7.05,13.75a11.1,11.1,0,0,1-13.43,7.65l-.79-.19c-1.11-.25-3-.67-5.39-1.42-29.76-9.22-153-51-214.22-126.76-15.93-19.75-27.67-41.82-32.44-66.21-21.9,9.86-43.42,20.43-64,31.44a10.79,10.79,0,0,1-13.49-2.72A11.06,11.06,0,0,1,3624,3857.07Zm85.21-33c18.2,116.74,205.06,180.24,242.33,191.78,2.14.66,3.76,1,4.83,1.27.53.12.93.21,1.19.29a3.55,3.55,0,0,0,4.19-2.51c.53-1.85-.48-4.06-2.08-4.55l1.11-3.58-1.25,3.53-.22-.06c-10.24-3.05-64.1-19.78-119-50-33.42-18.41-60.68-38.26-81-59-25.55-26.05-40.29-53.66-43.82-82.07l-.35-2.79,2.58-1.1c93.18-40,196.12-68.9,306-86l.94-.14.9.32c135.71,49.13,206,155,206.74,156.07a3.33,3.33,0,0,0,5.58-3.65c-2.57-3.94-64.27-97.06-186.92-149.57l-12.43-5.32,13.4-1.82c234.64-31.87,418-.25,419.8.07a3.33,3.33,0,1,0,1.16-6.56c-1.12-.2-114-19.79-273.23-13.5a1537.87,1537.87,0,0,0-169,16.05l-13.75,2.09,10.85-8.7c84.69-67.91,200.9-201.5,205.8-207.16a3.33,3.33,0,1,0-5-4.36c-1.41,1.62-142,163.16-226.12,222.33l-.69.48-.83.14a1342,1342,0,0,0-189.44,46.82l-8.48,2.79,4-8c45.69-92.06,132.21-233.53,133.06-234.91a3.34,3.34,0,0,0-5.69-3.49l0,.08c-3.92,6.43-96.6,158.38-139.43,247.94l-.67,1.41-1.48.51A1120.42,1120.42,0,0,0,3632,3849a3.33,3.33,0,1,0,3.15,5.87c22.14-11.83,45.32-23.15,68.89-33.64l4.46-2Z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3102.08,3801.75c-.77,3.19-1.55,6.43-2.28,9.7l7.9,1.15c76.4,10.18,688.49,77.89,1070.77-314.09q4.64-4.65,9.1-9.38a948.93,948.93,0,0,0,130-173.4s56.74-90.3,51.07-250.59c-.08-3.55-.19-7.18-.43-10.81-3.73-72.9-20.4-159.54-60.55-258.31-.71-1.87-1.5-3.84-2.31-5.76,0,0-2.59-.52-7.55-1.44-46.46-8-299.43-42.94-568.32,91-3.5,1.72-7,3.5-10.48,5.3C3479.07,3008.41,3228.44,3267.79,3102.08,3801.75Z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3095.54,3807.31l4.26,4.14,4.31,4.18,3.59-3L4307.63,2796c-.71-1.87-1.5-3.84-2.31-5.76,0,0-2.59-.52-7.55-1.44L3102.08,3801.75Z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3719,2885.14l87.89,326.76,11.53-1.4-88.94-330.66C3726,2881.56,3722.44,2883.34,3719,2885.14Z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3588.09,3397.91l-8.34,9.58,598.72,91q4.64-4.65,9.1-9.38Z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4033.91,3014.87l-.15,10.75,334.85,39.52c-.08-3.55-.19-7.18-.43-10.81Z"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1707.49,4217.58c.8,3.36,1.62,6.76,2.39,10.2l-8.3,1.2c-80.23,10.69-723,81.8-1124.53-329.86q-4.86-4.87-9.55-9.85A997,997,0,0,1,431,3707.17s-59.59-94.84-53.63-263.18c.08-3.73.19-7.54.45-11.35,3.92-76.56,21.42-167.55,63.59-271.28.74-2,1.57-4,2.42-6.05,0,0,2.72-.54,7.94-1.51,48.78-8.4,314.46-45.1,596.85,95.58,3.67,1.82,7.36,3.69,11,5.58C1311.57,3384.41,1574.78,3656.82,1707.49,4217.58Z"
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1714.35,4223.42l-4.47,4.36-4.52,4.38-3.78-3.18L441.41,3161.36c.74-2,1.57-4,2.42-6.05,0,0,2.72-.54,7.94-1.51L1707.49,4217.58Z"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1059.62,3255l-92.3,343.16-12.11-1.47,93.41-347.27C1052.29,3251.2,1056,3253.07,1059.62,3255Z"
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1197.07,3793.47l8.76,10.06-628.78,95.59q-4.86-4.87-9.55-9.85Z"
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M728.87,3391.2l.16,11.29L377.37,3444c.08-3.73.19-7.54.45-11.35Z"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M3222.73,3304.2c-2.23,1.17-4.48,2.37-6.77,3.53,0,0-.81-1.93-2.34-5.64-22-54.71-188.3-495.69,29.83-853.45q2.57-4.32,5.23-8.53a726.42,726.42,0,0,1,103.92-129.24s56.19-59.19,176.11-85.38c2.65-.62,5.36-1.22,8.09-1.73,54.76-11.06,122.16-15.13,203-4.09,1.52.17,3.13.38,4.71.62,0,0,.88,1.82,2.5,5.33,14.74,32.93,88.62,213.86,40.28,438.62-.62,2.92-1.27,5.87-1.95,8.78C3739.45,2874.26,3594.66,3109.27,3222.73,3304.2Z"
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3219.85,3310.1l-3.89-2.37-3.91-2.4,1.57-3.24L3739.8,2219.67c1.52.17,3.13.38,4.71.62,0,0,.88,1.82,2.5,5.33L3222.73,3304.2Z"
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3785.34,2673l-258.92-3.21-1.16-8.81,262,3.24C3786.67,2667.16,3786,2670.11,3785.34,2673Z"
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3430,2867.28l-5.52,8-181-426.65q2.57-4.32,5.23-8.53Z"
});

var _ref54 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M3629.45,2464.11l-7.95,2.15-92.79-240.77c2.65-.62,5.36-1.22,8.09-1.73Z"
});

var _ref55 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M2166.87,3407.86c4.35-.86,8.78-1.71,13.21-2.64,0,0-1-3.57-3-10.37-30.38-99.68-290.79-890.52-987.55-1140.61q-8.31-3.07-16.64-5.92c-88.41-30.34-183.69-51.94-286.25-62.49,0,0-142.92-19.08-336.89,77.9-4.32,2.09-8.72,4.26-13.05,6.59C449.11,2315.85,351.89,2385,253,2489.84c-1.9,1.92-3.88,4-5.79,6.07,0,0,.82,3.48,2.46,10.1C265.9,2567.64,365,2898.4,680.7,3153.9c4.09,3.33,8.25,6.66,12.42,9.9C979.43,3389.66,1439.18,3552.27,2166.87,3407.86Z"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M2177.37,3412.78l2.71-7.56,2.72-7.65-5.75-2.72L253,2489.84c-1.9,1.92-3.88,4-5.79,6.07,0,0,.82,3.48,2.46,10.1l1917.23,901.85Z"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M693.12,3163.8l352.53-291.57-8.19-13.4L680.7,3153.9C684.79,3157.23,689,3160.56,693.12,3163.8Z"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M1397.28,3036.85l16.46,4.89-224.24-787.5q-8.31-3.07-16.64-5.92Z"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M675.83,2703.61l13.31-5.85-139.42-434c-4.32,2.09-8.72,4.26-13.05,6.59Z"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M2108.54,2828c-58-34.81-115.18-70.15-181.68-72.15-40.74-1.22-82,10.74-119.88,24.57-34.32,12.54-63.89,33.38-100.3,42.71-73.68,18.89-154.31,12.07-222.63-21.92-20.88-10.38-41.5-24-52.26-44.7-11.44-22-9.82-49-1.33-72.26,17.83-48.93,61.89-84.64,71.64-137.3,12.29-66.4-50.52-134.63-116.94-127-29.78,3.41-61.67,18.86-87.85,4.51-35.24-19.31-27.46-73.33-7.67-109s47.8-73.6,37.38-112.77c-21.75-81.74-173-58.46-195.26-140-11.76-43.07,26.73-87.2,69.76-98.62s88.08.27,131.13,10.62,89.47,19.18,130.89,2.64c65.59-26.18,93.4-104.65,102.72-175.08,4.19-31.66,8.51-67.74,34.28-86.47,19.37-14.09,46.62-13.49,67.71-2.69s36.62,30.33,47.6,51.47c24.72,47.59,28.58,103.12,36.11,156.48s20.89,109.29,59,146.78,108,46.23,142.77,4.87c20.77-24.69,24-59.15,33.59-90s33.3-63.39,65.12-61.31c25.5,1.67,43.68,24.91,56.1,47.34,46.57,84,59.64,186.64,35.76,280.61-9.08,35.72-23.29,70.35-27.79,106.91s2.63,77.14,29.71,101.44c28.55,25.63,72.07,27.43,102.31,51,35.73,27.85,44.13,78,49.94,123.38,6.25,48.73,3.23,114.3,28.72,156.43,18.72,30.94,35.11,66.53-6.93,93.09-28,17.71-64.24,14-95.53,4.14C2183.8,2872.75,2146,2850.48,2108.54,2828Z"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M1192.53,1978.66a9.94,9.94,0,0,1,12-7.28c1.55.38,157.9,39.18,359.06,137.48a2159.26,2159.26,0,0,1,208.23,116.4c-70.48-135.42-143.85-371.93-147.22-382.83a9.91,9.91,0,0,1,18.94-5.84c.89,2.88,89.53,288.63,163.81,411.73,71.6,47.56,145.48,103.18,217.08,167.56-6.56-143.64-37.51-373.54-37.84-376a9.91,9.91,0,1,1,19.64-2.66c.34,2.56,34.35,255.13,38.75,397.42a1568.42,1568.42,0,0,1,167,180.87,9.91,9.91,0,1,1-15.59,12.23q-33.4-42.58-69.1-81.78c-91.07,142.18-369.87,117.62-424.13,111.36-4.67-.53-7.64-1.26-8.72-1.41a10.22,10.22,0,0,1-8.43-11.5c.74-5.35,5.69-9.76,11-9.15l.21,0c3.31.38,327.16,43.83,415.93-104.69-107.14-114.89-226.54-207.93-342.75-282.32-199.89-13.56-348.61,81.5-350.09,82.47a9.91,9.91,0,0,1-10.82-16.6c5.92-3.87,138.83-89,327.14-87-280.29-171.87-532.95-235.55-536.89-236.52A9.91,9.91,0,0,1,1192.53,1978.66Z"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M2211.14,2635.13a15.17,15.17,0,0,1-18.85-4.13c-20.21-25.77-41.84-51.49-64.35-76.51-19.89,28.58-47.42,50.25-79,66.56-121.31,62.64-303,46.51-346.33,41.51-3.52-.41-6.15-.92-7.72-1.23l-1.12-.21a15.52,15.52,0,0,1-12.9-17.39c1.15-8.31,8.85-14.56,16.81-13.64l-.38,5.23.6-5.2.43.05c14.67,1.86,92.2,10.73,178.64,3.06,80.09-7.1,184.33-30.6,229.7-101.95-95.47-101.84-209.11-195.29-337.88-277.83-197.2-12.91-344.08,80.77-345.55,81.72a15.15,15.15,0,0,1-16.54-25.38c5.44-3.55,131.25-84.28,311.43-87.79-275-165.34-517.09-225.68-519.55-226.28a15.16,15.16,0,0,1-11.11-18.31h0a15.2,15.2,0,0,1,18.29-11.11c1.58.39,158.54,39.35,360.14,137.87a2167.41,2167.41,0,0,1,192.72,106.61c-67.94-137.68-136-357.14-139-366.79a15.14,15.14,0,1,1,28.94-8.94c.88,2.86,89,286.66,162.69,409.57a1899.1,1899.1,0,0,1,207.35,159c-7.68-143.88-36.88-360.83-37.18-363a15.15,15.15,0,1,1,30-4.07l0,.14c1.4,10.43,34.11,255.65,38.71,395.63,61.15,57,117,117.51,166,180a15.14,15.14,0,0,1-2.57,21.26A14.23,14.23,0,0,1,2211.14,2635.13Zm-84.54-97.73,4.6,5.07c24.3,26.77,47.63,54.38,69.34,82.07a4.67,4.67,0,0,0,3.14,1.76,4.67,4.67,0,0,0,4.21-7.52c-49.09-62.6-105.1-123.25-166.48-180.28l-1.6-1.49-.07-2.18c-4.31-139.06-37.29-386.29-38.69-396.75l0-.14a4.67,4.67,0,0,0-9.26,1.26c.31,2.26,31.31,232.56,37.88,376.44l.58,12.51-9.31-8.37c-65.82-59.19-138.65-115.41-216.48-167.1l-1-.65-.61-1c-74.48-123.44-163.44-410-164.33-412.9a4.67,4.67,0,1,0-8.92,2.75c3.09,10,76.62,247,146.85,382l9,17.28L1769,2229.68a2152.14,2152.14,0,0,0-207.72-116.11c-200.6-98-356.46-136.72-358-137.1a4.67,4.67,0,0,0-2.22,9.08c2.52.61,255.49,63.67,538.38,237.13l16.15,9.91-18.94-.2c-187-2-318.71,82.57-324.23,86.17a4.67,4.67,0,0,0,2,8.55,4.56,4.56,0,0,0,3.07-.72c1.5-1,151.52-97,353.31-83.31l1.34.09,1.13.73c131.2,84,246.85,179.24,343.76,283.16l2.68,2.88-2,3.38c-20.58,34.43-55.09,61.5-102.58,80.47-37.81,15.1-84,25.16-137.25,29.88-87.5,7.76-166-1.23-180.87-3.11l-.32,0,.39-5.23-.6,5.21c-2.33-.27-4.88,2-5.24,4.66a5,5,0,0,0,4,5.59c.38.05,1,.16,1.7.3,1.51.3,3.79.74,6.9,1.1,54.33,6.26,329.83,30.43,419.13-109Z"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M3923.91,930.27c0-195-219.4-353.12-490-353.12s-490,158.09-490,353.12,219.4,353.11,490,353.11a659.73,659.73,0,0,0,173.76-22.87l89.8,111.58,52.15-171.78C3856.17,1135.54,3923.91,1038.61,3923.91,930.27Z"
});

var _ref64 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3360.05,
  y: 810.34,
  width: 98.17,
  height: 27.68,
  rx: 0.76
});

var _ref65 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3227.86,
  y: 810.34,
  width: 98.17,
  height: 27.68,
  rx: 0.76
});

var _ref66 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3313.03,
  y: 978.17,
  width: 98.17,
  height: 27.68,
  rx: 0.76
});

var _ref67 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3441.58,
  y: 978.17,
  width: 196.1,
  height: 27.68,
  rx: 1.28
});

var _ref68 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3494.56,
  y: 810.34,
  width: 145.32,
  height: 27.68,
  rx: 0.92
});

var _ref69 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3281.17,
  y: 892.72,
  width: 352.14,
  height: 27.68,
  rx: 1.18
});

var _ref70 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-1",
  x: 3270.38,
  y: 1057.11,
  width: 293.67,
  height: 27.68,
  rx: 1.18
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M2888.57,2049.19c-10.69,127.6,6.68,288.55,43.88,411.07,7.84,25.81,16.74,53.52,8.26,79.13-9.4,28.43-37.41,45.89-64,59.66a945,945,0,0,1-388.09,104.29c-37.07-68.88-81.36-132-91.65-209.56-3.94-29.75-3.12-69.56-12.6-98-10.51-31.57-25.76-82.21-38.73-111.26,64.06-68.69,152.29-101.45,224.57-161.43,30.62-25.41,62.17-50.14,97.48-68.47s74.86-30.06,114.59-27.88S2864.08,2017.83,2888.57,2049.19Z"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M2831.62,2087.83c-31.83,93.07-68.2,179.82-111.63,263.83-14.5,28.05-32,57.22-60.85,70.13-19.2,8.61-41,8.8-62,8.83-51.56.09-204-6.33-207.28-13.14-11.88-24.63-9-44-20.87-68.6,66.18,17.44,122.88,16.26,185.28-1.37s121.19-47,164.34-95.43S2798.14,2145.56,2831.62,2087.83Z"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M2105.3,1906.68c6.83,114.7,23.17,235.21,92.94,326.51,56.81,74.34,146.72,121.93,240,128.84s188.59-26.48,258.35-88.83c56.14-50.16,94.91-116.41,132.74-181.49l131.14-225.56c22.9-39.41,46.66-84,35.84-128.29-8.56-35-37-61.26-65.11-83.89a1165.67,1165.67,0,0,0-520.4-238c-73.52-13.35-150.7-19.33-221.86,3.46a244.18,244.18,0,0,0-87.12,49.26c-22.12,19.6-52,52-54.9,83.06-1.31,13.8,6.54,23.88,12.41,35.63,8.56,17.14,13.41,36.08,18,54.6,10,40.28,15.55,81.53,19.22,122.82C2100.8,1812,2102.49,1859.39,2105.3,1906.68Z"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M2917.93,2005.24c22.54-46,52.59-87.88,76.81-133,81.37-151.59,91.83-339.4,27.81-499.1-23.64-59-59.11-116.35-114-148.4-67.56-39.47-150.87-33.92-228.9-39.57a745.25,745.25,0,0,1-350.39-117.72c-41.78-27.14-81.37-58.78-127.8-76.85-101.67-39.57-225.28-2.92-296.46,79.75s-90.31,204-57.55,308.06,128,197.71,225.53,246.65c-12.2-24.58-13.74-60.83,1.83-84.54,16.31-24.83,54.33-38.11,81.77-44,31-6.65,63.07-6.65,94.81-6.62l197.93.2c57.85.06,118.88,1,168.6,30.52,47.75,28.41,77.32,78.67,106.57,125.91,10.94,17.67,22.27,35.39,36.73,50.43,5.55,5.78,13.47,15.34,21.66,17.14,8,1.77,20-2.1,27.15-5.35,11-5,18.74-15.74,29.22-20.53s26.22-5.6,37.57-7.64c24.26-4.35,50.17-6.31,72.5,6.15,43.7,24.38,46.15,88.69,24.68,133.88s-59.61,80.57-83,124.82c-29.27,55.48-36.38,136.17-4.67,192.41C2890.77,2090,2896.33,2049.29,2917.93,2005.24Z"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  className: "cls-6",
  d: "M2064.66,1597.88c18.62-22.21,54.37-34.44,80.72-40.08,32.22-6.92,65.5-6.92,98.47-6.88l205.54.2c60.09.06,123.48,1,175.11,31.7,49.59,29.5,80.3,81.7,110.68,130.76,11.36,18.35,23.13,36.76,38.15,52.39,5.76,6,14,15.92,22.49,17.78,8.35,1.84,20.76-2.17,28.19-5.55,11.4-5.17,19.47-16.35,30.34-21.33s27.25-5.81,39-7.91c25.19-4.52,52.11-6.58,75.28,6.38a68.53,68.53,0,0,1,18.28,14.77c2.08-33.89-8.79-67.32-37.59-83.39-22.34-12.45-48.25-10.5-72.52-6.13-11.33,2-27.16,2.87-37.57,7.62s-18.24,15.55-29.2,20.55c-7.17,3.24-19.12,7.1-27.16,5.34s-16.12-11.35-21.66-17.14c-14.45-15-25.78-32.75-36.72-50.42-29.27-47.24-58.82-97.51-106.58-125.92-49.72-29.57-110.75-30.47-168.6-30.51l-197.94-.2c-31.74,0-63.77,0-94.81,6.62-27.44,5.88-65.45,19.16-81.76,44C2064.4,1556.42,2061.64,1578,2064.66,1597.88Z"
});

var _ref76 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-5",
  cx: 2883.09,
  cy: 1796.58,
  rx: 148.92,
  ry: 95.36,
  transform: "translate(264.19 3960.2) rotate(-71.49)"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1910.47,1427.87l3.06-10.52c-62.29-18.06-94.87-82.76-103.84-132.67-23.59-131.27,72-275.65,208.76-315.29a280.46,280.46,0,0,1,178.19,7.75c43.07,16.66,81.86,44.09,119.38,70.62,12.63,8.94,25.69,18.17,38.76,26.89a862.41,862.41,0,0,0,313.12,128.4l2.07-10.77a851.38,851.38,0,0,1-309.11-126.75c-12.94-8.63-25.94-17.83-38.51-26.72-38.06-26.91-77.42-54.75-121.76-71.89a291.36,291.36,0,0,0-185.19-8c-66.07,19.15-127.56,64.66-168.7,124.88-43,63-60,135-47.8,202.87C1811.45,1356.41,1855.24,1411.86,1910.47,1427.87Z"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M3017.52,1822.33c67.14-88.19,117.59-239.88,84.08-359.15-31.93-113.65-120.08-210.93-230-253.87l-4,10.21c106.83,41.71,192.46,136.22,223.48,246.63,32.54,115.81-16.75,263.51-82.25,349.54Z"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  className: "cls-7",
  d: "M1979,1089.84l6.35-3.82c4.08-2.62,10.36-5.91,18.31-10a269.66,269.66,0,0,1,29.8-12.5c5.82-2.21,12.24-3.93,18.92-5.92l10.42-2.55c3.54-.92,7.25-1.46,11-2.23a271.34,271.34,0,0,1,49-4.33,255.75,255.75,0,0,1,54.26,6.15c2.26.53,4.75,1,6.85,1.58l7.06,2c4.81,1.24,9.3,2.85,13.89,4.39,9.16,3.12,18.37,6.93,27.5,10.93,18.27,8.13,36.08,18.14,53.46,28.89s34.49,22.12,51.23,33.55,33.32,22.67,49.65,33.11a546.63,546.63,0,0,0,48.73,27.91,357.67,357.67,0,0,0,46.36,19.67c3.7,1.27,7.3,2.54,10.91,3.52s7.08,2.13,10.54,3l10.13,2.33c3.27.8,6.54,1.19,9.65,1.78,6.22,1.22,12.15,1.69,17.59,2.29,2.71.36,5.36.29,7.86.45l7.16.28c4.53,0,8.58-.21,12.09-.32l2.53-.1,2.33-.25,4-.43,7.37-.8-7.41.2-4,.11-2.32.07-2.52-.11c-3.5-.19-7.51-.27-12-.55l-7.05-.75c-2.45-.32-5-.41-7.7-1-5.31-1-11.1-1.69-17.14-3.25a264.88,264.88,0,0,1-39.87-12.38,402.19,402.19,0,0,1-44.73-21c-15.43-8.37-31.24-18.18-47.22-28.71s-32.21-22.29-49-33.79-33.81-23.23-51.48-34.15-36-21-54.9-29.22a294.63,294.63,0,0,0-28.66-11c-4.87-1.54-9.73-3.14-14.45-4.26l-7.1-1.85c-2.61-.66-4.91-1-7.36-1.57a245.59,245.59,0,0,0-56.38-4.89,253.54,253.54,0,0,0-50.13,6.34c-3.8,1-7.56,1.67-11.14,2.77l-10.51,3.1c-6.71,2.4-13.12,4.5-18.91,7.08a240.55,240.55,0,0,0-29.34,14.48c-7.79,4.67-13.74,8.56-17.61,11.46Z"
});

var _ref80 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-6",
  cx: 2895.1,
  cy: 1814.41,
  rx: 96.84,
  ry: 44.59,
  transform: "translate(255.48 3983.77) rotate(-71.49)"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M2799.71,1184.51a64.86,64.86,0,0,1,46.05,18.7c12.22,12,20.2,27.69,27.07,43.41,23.19,53,30.2,116.81,35.15,177.55,4.61,56.37-10,175.45-12.88,233.84-17.3,1.77-48.27,1.47-63.82,4.63-2-135.55,8.59-215.78-34.11-359.57-10.28-34.6-32.63-69-41.92-84.92s-26.18-31.25-44.5-33.45C2740.41,1183.26,2768.71,1184.86,2799.71,1184.51Z"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M3145.07,2584.67c-9.54-37-45.81-64.82-82.05-77.08-13.32-4.51-26.88-8.36-40.61-11.8-8.87-2.2-17.67-4.25-26.65-6.2-111.25-24.07-225-3.16-338.29,4.79-113.15-8-227-28.86-338.22-4.79q-13.47,2.92-26.79,6.2c-13.72,3.44-27.28,7.29-40.6,11.8-36.24,12.26-72.51,40-82,77.08-5.94,23.14,2.76,47.21,11.33,69.49,31.77,82.51,66.78,169.39,137.33,222.65,39.94,30.15,88.29,47,136.65,59.91a1075.14,1075.14,0,0,0,202.44,33.85,1072.62,1072.62,0,0,0,202.3-33.85c48.37-13,96.64-29.76,136.58-59.91,70.56-53.26,105.53-140.14,137.3-222.65C3142.33,2631.88,3151,2607.81,3145.07,2584.67Z"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  className: "cls-9",
  d: "M3601.63,2865.36c-43.19-65-114.4-145.11-171.32-198.47a463,463,0,0,0-65.62-51c-51-33-107.39-56.5-165-75.17-29.29-9.5-59-17.73-88.8-25.33-26.48-6.75-60.18-20.78-87.6-19.69s-58.07,20.39-84,29a1025.53,1025.53,0,0,1-305.16,52.5q-27.85.51-55.72-.64c-66.15-2.8-132.31-13-195.29-33.76-31.72-10.45-60.11-26.45-90.74-39-25.19-10.31-55.7,3.28-82.23,10-116.62,29.34-236.13,69.19-325.59,153.12-56.92,53.36-97.92,121.27-135.43,189.69-189.82,346.17-311.82,742-429.16,1118.89,133.79-69.36,293.51-80.33,437.09-34.42,28.4-82.09,58.07-166.14,90.15-249.25v0q33.24-89.36,73.92-175.72c25.93-54.73,52.3-120.41,90.86-167.14,2.15,68.72-16,143-21.19,212.17q-8.07,108.39-9.43,217.14-1.65,132.14,6.61,264.16c2.82,44.94,9.65,324.64,39,325.79,23.46.91,1267.72,11.84,1280.49-.67,7.39-7.24,19-245.13,19.72-262.48,2.74-71.09-1-142.22-4.79-213.19q-1.9-35.71-3.79-71.41-5.92-111.57-11.84-223.14-3-55.79-5.92-111.57c-1.83-34.52-11.44-77.72-6-111.72,7-43.65,35.13,18.55,43,32.74q25.24,45.5,47.94,92.36c30.51,62.83,57.77,127.22,82.13,192.68v0c32.07,83.11,61.61,167.16,90,249.25,143.57-45.91,296.08-42.26,429.87,27.1C3892.49,3570.11,3858.24,3251.54,3601.63,2865.36Z"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M2036.15,3454.5c-.89-4.67-1.81-9.37-2.69-14,.88,4.74,1.73,9.55,2.54,14.29Z"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M1847.24,3691.76c47-120.68,100.27-239.34,166-347.05q7.47,30.78,13.72,61.69-40.42-211.91-80.89-423.77c-16.13,90.27-27.73,180.39-43.82,270.65C1876.42,3398.3,1850.45,3545.08,1847.24,3691.76Z"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  className: "cls-10",
  d: "M3278.72,3454.5c.89-4.67,1.81-9.37,2.69-14-.88,4.74-1.73,9.55-2.55,14.29C3278.83,3454.68,3278.76,3454.57,3278.72,3454.5Z"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  className: "cls-11",
  d: "M3467.88,3709.94c-52.65-134.83-174.75-336.46-174.69-312.25q-2.43-248.54-4.82-497c25.45,102.67,47.56,205.61,73,308.29C3402.17,3373.91,3443.36,3540.9,3467.88,3709.94Z"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M3969.4,3892.53c52.76,184,29.43,297.54,13.46,344.62a57.26,57.26,0,0,1-39,36.91c-201.41,55.4-1001.48-105.32-1001.48-105.32l.11-1.19c-44.67-.24-89,3.78-131.71,17.29a305.12,305.12,0,0,0-81.08,39.46c-20.13,13.85-39,30.48-60.89,40.33s-48,12-68.31-2.83c-12.17-8.87-21.57-23.26-35-28.86-25.9-10.77-56.68,14.94-80.09-2.18-15.64-11.44-19.94-37.25-35.26-49.28-17.51-13.76-41.49-4-61-13.18-10.11-4.76-18.08-14.18-25.74-23.35l-50.82-60.85c-14.11-16.9-29.53-38.06-20.95-61.8a39.75,39.75,0,0,1,13.06-17.77c16.33-12.73,35.84-12.75,54.17-17.79,90.76-25,130.82-162.15,221-189.55,99.22-30.15,166.86,93.23,254.05,122.22,28.8,9.58,59.06,8.41,88.71,6.75q70-3.91,139.88-10.86c106.27-8.68,214.38-7.3,321.3-11.6,13.64-.55,153.69-56.59,154.6-51.65,0,0,84.54-28.72,192.4-21.68S3969.4,3892.53,3969.4,3892.53Z"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M3597.55,3180.56c-43.34-73.65-125.82-121.54-200.78-158.66-22.14-11-45-22.3-66.68-34.47-59.32-33.33-133-89.95-147.21-170.39-6.09-34.45-.66-70.94,4.59-106.24,5.79-38.84,11.77-79,3.32-118.59-16.12-75.61-77.46-126.16-136.77-175-16-13.19-32.54-26.82-47.62-40.54-132.85-120.87-199.33-313.4-169.35-490.49l-10.8-1.83c-30.59,180.67,37.23,377.11,172.77,500.43,15.28,13.9,31.93,27.62,48,40.88,57.87,47.69,117.71,97,133,168.88,8,37.63,2.2,76.81-3.44,114.69-5.38,36.16-11,73.55-4.55,109.75,15,84.67,91.26,143.55,152.64,178,21.91,12.32,44.92,23.71,67.18,34.74,73.52,36.41,154.32,83.23,196.2,154.39,50.06,85.07,51.31,206.83,30.34,289.76-25.72,101.71-96.61,185.82-185,219.51-84.9,32.36-179.69,18.83-252.78,3.42-21.06-4.44-42.45-9.47-63.14-14.34-62.64-14.75-127.42-30-192.92-31.11-73.2-1.22-147.66,16.31-215.37,50.73s-125.76,84.26-167.89,144.12c-10.42,14.8-20,30.36-29.24,46.09q3.16,5.57,6.15,11.23c10.07-17.44,20.61-34.75,32.06-51,82.9-117.81,222.93-190.25,366.85-190.25,2.42,0,4.83,0,7.26.07,64.32,1.09,128.51,16.19,190.59,30.81,20.75,4.88,42.21,9.93,63.39,14.4,74.56,15.71,171.37,29.46,258.94-3.91,91.67-34.93,165.13-121.94,191.72-227.06C3650.59,3393.45,3649.19,3268.3,3597.55,3180.56Z"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M2774.52,1905.34c38.52,28.53,100,18,126.83-21.77,16-23.8,19.65-53.71,20.64-82.39a573.35,573.35,0,0,0-11.74-136.87c-5.7-27.28-19.24-59.4-47-62.06-17.44-1.68-33.34,9.7-45.93,21.88C2761,1678.62,2691.77,1844,2774.52,1905.34Z"
});

var _ref91 = /*#__PURE__*/React.createElement("ellipse", {
  className: "cls-8",
  cx: 2500.31,
  cy: 2222.96,
  rx: 86.69,
  ry: 66.32
});

var _ref92 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M2814.64,1851.71c4.14,65.52-23.92,129.45-62.29,182.71-21.07,29.25-45.53,56.31-74.39,77.92a248.1,248.1,0,0,1-31.54,20.62L2607,2154.3c-24.47,13.25-48.84,26.68-73.42,39.7-7.47,4-11.23,7.88-15.19,15.41a102.53,102.53,0,0,1-9.92,15.7c-1.38,1.77-9.37,12.75-11.6,12.29a91.4,91.4,0,0,0,31.25,1c3.88-.59,6.24-2.26,9.71-3.78,4.61-2,9.8-3,14.57-4.61a360.84,360.84,0,0,0,80.38-38.08c25.2-16,50.4-30.62,73.34-50.15a319.75,319.75,0,0,0,29.17-28.21c9.57-10.51,19.18-20.4,29.16-30.54a305.91,305.91,0,0,0,50.58-67.53c23.89-43.66,35.25-92.61,38.06-142q.33-5.65.51-11.31c-8.53-1.55-16.83-3.83-25.18-6.1C2823.79,1854.78,2819.3,1853,2814.64,1851.71Z"
});

var _ref93 = /*#__PURE__*/React.createElement("path", {
  className: "cls-8",
  d: "M2898,3955.57a78.09,78.09,0,0,1-78.09,78.08H1054.34a78.1,78.1,0,0,1-78.11-78.08V2651.63a78.1,78.1,0,0,1,78.11-78.1H2819.86a78.08,78.08,0,0,1,78.09,78.1Z"
});

var _ref94 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "1655.5 3430.9 1544.25 4034.57 1578.67 4034.57 1655.5 3430.9"
});

var _ref95 = /*#__PURE__*/React.createElement("polygon", {
  className: "cls-12",
  points: "1939.19 3429.66 2128.82 4033.48 2004.15 4033.48 1939.19 3429.66"
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M1994.53,4228.14h-408.3c-17.4,0-29.86-14.12-27.7-31.38l97.12-767.7c1.76-17.3,17.41-31.45,34.81-31.45h214.72c17.38,0,33.16,14.14,35,31.44l82.58,767.64C2024.62,4214,2011.91,4228.14,1994.53,4228.14Z"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  className: "cls-13",
  d: "M1891.41,3762.92a100.79,100.79,0,1,0-100.79,100.79A100.79,100.79,0,0,0,1891.41,3762.92Z"
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M2022.92,4197.94l-82.58-768.2c-1.85-17.29-17.34-31.17-34.72-31.17h-10.87c17.38,0,32.87,14.26,34.72,31.56l82.58,767.73c1.85,17.3-10.86,32.4-28.25,32.4h10.87C2012.06,4230.26,2024.76,4215.24,2022.92,4197.94Z"
});

var _ref99 = /*#__PURE__*/React.createElement("rect", {
  className: "cls-13",
  x: 1364.53,
  y: 4211.21,
  width: 852.18,
  height: 83.55
});

var _ref100 = /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M2816.38,4033.65H2796V2573.79h20.4a81.57,81.57,0,0,1,81.57,81.57V3952.08A81.57,81.57,0,0,1,2816.38,4033.65Z"
});

var _ref101 = /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M4405.68,4422.85H519c-34.63,0-62.71-31-62.71-69.2h0c0-38.23,28.08-69.21,62.71-69.21H4405.68c34.63,0,62.71,31,62.71,69.21h0C4468.39,4391.87,4440.31,4422.85,4405.68,4422.85Z"
});

function SvgContactus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5000 5000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactus);
export default __webpack_public_path__ + "static/media/contactus.598cdf25a51b847ac7d7183b7859a1f8.svg";
export { ForwardRef as ReactComponent };